import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import { 
    fileImage1, 
    fileImage10, 
    fileImage11, 
    fileImage12, 
    fileImage13, 
    fileImage2,
    fileImage3,
    fileImage4,
    fileImage5,
    fileImage6,
    fileImage7,
    fileImage8,
    fileImage9,
 } from '../../assets/images'

export default function ImageGallery() {

    const imageGallery = [
        {
            image: fileImage1,
        },
        {
            image: fileImage2,
        },
        {
            image: fileImage3,
        },
        {
            image: fileImage4,
        },
        {
            image: fileImage5,
        },
        {
            image: fileImage6,
        },
        {
            image: fileImage7,
        },
        {
            image: fileImage8,
        },
        {
            image: fileImage9,
        },
        {
            image: fileImage10,
        },
        {
            image: fileImage11,
        },
        {
            image: fileImage12,
        },
        {
            image: fileImage13,
        },
    ]

    return (
        <>
            <Breadcrumb title="Image Gallery" path="Pages / Image Gallery" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='text-[16px]/[19.2px] font-medium mb-5'>
                    Image Gallery
                </div>
                <div className='mb-30 text-text-secondary'>
                    All pictures taken from pexels.com
                </div>
                
            </div>
        </>
    )
}
